export const isMobile = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  const mobileKeywords = [
    'mobile',
    'android',
    'iphone',
    'ipod',
    'ipad',
    'windows phone'
  ]
  console.log('userAgent', userAgent)
  
  return mobileKeywords.some(keyword => userAgent.includes(keyword))
} 